import type { Empfaenger } from './api';

/**
 * Kassenbeleg (§ 132a BAO) braucht bei keinem Betrag einen Empfänger. Wer einen Empfänger
 * angibt, verlangt ausdrücklich eine Rechnung (§ 11 UStG): bis 400 € Kleinbetragsrechnung,
 * darüber vollständige Rechnung (Name, Anschrift, UID des Unternehmers – prüft der Server);
 * über 10.000 € an einen Geschäftskunden zusätzlich dessen UID.
 */
export const KLEINBETRAG_GRENZE_CENT = 40_000;
export const UID_EMPFAENGER_GRENZE_CENT = 1_000_000;

export const KEIN_EMPFAENGER = { name: '', anschrift: '', uid: '' };

/**
 * Empfänger für den Beleg aus den Eingaben; undefined ohne Eingabe (Kassenbeleg bei jedem
 * Betrag). Der Betrag selbst verlangt nie einen Empfänger.
 */
export function empfaengerFuer(
  _summeCent: number,
  eingabe: { name: string; anschrift: string; uid: string },
): { empfaenger?: Empfaenger; fehler: string | null } {
  const name = eingabe.name.trim();
  const anschrift = eingabe.anschrift.trim();
  const uid = eingabe.uid.trim();
  if (name === '' && anschrift === '') {
    return { fehler: null };
  }
  if (name === '' || anschrift === '') {
    return { fehler: 'Empfänger: Name und Anschrift gemeinsam angeben' };
  }
  return { empfaenger: { name, anschrift, ...(uid === '' ? {} : { uid }) }, fehler: null };
}
